import { render, staticRenderFns } from "./SettingsCompany.vue?vue&type=template&id=1600d983&"
import script from "./SettingsCompany.vue?vue&type=script&lang=js&"
export * from "./SettingsCompany.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCompany.vue?vue&type=style&index=0&id=1600d983&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports